import { PayloadAction } from '@reduxjs/toolkit';

import { AddonData, AddonsState } from 'editor/src/store/editorModules/addons/types';

const appendAddonsDataReducer = (state: AddonsState, action: PayloadAction<AddonData | undefined>) => {
  const newData = action.payload;
  if (!newData || !state.data) {
    return;
  }

  // Append new subcategories to existing ones
  if (newData.results?.category?.subcategories && state.data.results?.category?.subcategories) {
    state.data.results.category.subcategories = [
      ...state.data.results.category.subcategories,
      ...newData.results.category.subcategories,
    ];
  }

  // Update the more flag
  state.data.more = newData.more;
  state.data.resultsVersion = newData.resultsVersion;
  state.loadingMore = false;
};

export default appendAddonsDataReducer;
